var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimilarCompanyAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12462 7871 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n        opacity: 0.35;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "similar_company_add",
    transform: "translate(11722 7820)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "teal_circle",
    "data-name": "teal circle",
    className: "cls-1",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    transform: "translate(740 51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_add_white",
    className: "cls-2",
    d: "M3432.727,984.987h-3.74v3.74h-1.247v-3.74H3424V983.74h3.74V980h1.247v3.74h3.74Z",
    transform: "translate(-2676 -921.091)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilarCompanyAdd);
export default __webpack_public_path__ + "static/media/similar_company_add.ea0d0f812ee831c29f3bd63e3932543a.svg";
export { ForwardRef as ReactComponent };